const groupPrefix = createApiRoute(ApiModule.DIETARY, ApiDataModel.MEAL_PACKAGING)

export const apiMealPackaging = {
	fetchMealPackagingTypes: async () => {
		const { data, meta } = await apiCommon<IMealPackagingType[]>(`${groupPrefix}`, {
			method: 'GET',
		})
		return { data: data.map(d => MealPackagingType(d)), meta }
	},

	// addMealPackagingType: async (name: IMealPackagingTypeName[], isActive = true) => {
	// 	const { data } = await apiCommon<IMealPackagingType>(`${groupPrefix}`, {
	// 		method: 'POST',
	// 		body: mealPackagingTypeToJSON({ name, isActive }),
	// 	})
	// 	return MealPackagingType(data)
	// },

	// editMealPackagingType: async (mealPackagingID: number, name: IMealPackagingTypeName[], isActive = true) => {
	// 	const { data } = await apiCommon<IMealPackagingType>(`${groupPrefix}/${mealPackagingID}`, {
	// 		method: 'PUT',
	// 		body: mealPackagingTypeToJSON({ name, isActive }),
	// 	})
	// 	return MealPackagingType(data)
	// },

	// deleteMealPackagingType: async (mealPackagingID: number) => {
	// 	await apiCommon<string>(`${groupPrefix}/${mealPackagingID}`, {
	// 		method: 'DELETE',
	// 	})
	// },
}
